import React, { useEffect, useState } from 'react';
import styles from './Author.module.scss';
import cn from 'classnames';
import Image from 'next/image';
import parse from 'html-react-parser';
import { httpGet } from '../../utils/httpClient';
import News from '../News/News';
import LinkedInLogo from '../../public/LinkedIn.svg';
import { BCBreadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import moment from 'moment';

export function AuthorProfile({
  author,
  articles,
  airlineReviews,
  hotelReviews,
}) {
  const [authorBio, setAuthorBio] = useState(null);
  const [authorContent, setAuthorContent] = useState([]);

  useEffect(() => {
    if (author) {
      setAuthorBio(parse(author.content));
      const incomingContent = [
        ...articles.content.map((article) => ({
          ...article,
          contentType: 'article',
        })),
        ...airlineReviews.content.map((airlineReview) => ({
          ...airlineReview,
          contentType: 'airlineReview',
        })),
        ...hotelReviews.content.map((hotelReview) => ({
          ...hotelReview,
          contentType: 'hotelReview',
        })),
      ].sort((a, b) => (moment(b.published, 'YYYY-MM-DDTHH:mm').diff(moment(a.published, 'YYYY-MM-DDTHH:mm'))) > 0 ? 1 : -1);
      console.log(incomingContent.map(c =>  c.published + ' ' + c.title));
      setAuthorContent([...authorContent, ...incomingContent]);
    }
  }, [author]);
  useEffect(() => {
    getAuthorContent();
  }, []);
  const mapAuthorContent = (item) => ({
    ...item,
    type: item.type
      ? item.type
      : item.contentType === 'airlineReview'
      ? 'airlines'
      : 'hotel',
    title:
      item.contentType === 'airlineReview'
        ? `${item.title} ${item.cabinClass}`
        : item.title,
    subtype: item.subtype
      ? item.subtype
      : item.contentType === 'airlineReview'
      ? 'reviews'
      : 'review',
    heading:
      item.contentType === 'airlineReview'
        ? 'Airline Review'
        : item.contentType === 'hotelReview'
        ? 'Hotel Review'
        : null,
  });
  const getAuthorContent = async () => {
    const requestQueue = [
      await httpGet(
        `/api/author/${author.textId.toLowerCase()}/articles?page=0&size=10`
      ).then((r) => r.json()),
      await httpGet(
        `/api/author/${author.textId.toLowerCase()}/airline?page=0&size=10`
      ).then((r) => r.json()),
      await httpGet(
        `/api/author/${author.textId.toLowerCase()}/hotel?page=0&size=10`
      ).then((r) => r.json()),
    ];
    const contents = await Promise.all(requestQueue);
    let incomingContent = [];
    if (contents[0].content?.length) {
      incomingContent.push(
        contents[0].content.map((article) => ({
          ...article,
          contentType: 'article',
        }))
      );
    }
    if (contents[1].content?.length) {
      incomingContent.push(
        contents[1].content.map((article) => ({
          ...article,
          contentType: 'airlineReview',
        }))
      );
    }
    if (contents[2].content?.length) {
      incomingContent.push(
        contents[2].content.map((article) => ({
          ...article,
          contentType: 'hotelReview',
        }))
      );
    }
    incomingContent = incomingContent
      .flat()
      .map(mapAuthorContent)
      .sort((a, b) => (moment(b.published, 'YYYY-MM-DDTHH:mm').diff(moment(a.published, 'YYYY-MM-DDTHH:mm'))) > 0 ? 1 : -1);

    setAuthorContent([...authorContent, ...incomingContent]);
  };

  return (
    <>
      <div className={styles.profileBG}></div>

      <div className={cn(styles.profileInfo)}>
        <div className="flex flex-col">
          <div className={styles.profileImageWrapper}>
            {!author.image && (
              <div className={styles.profileImagePlaceholder}>
                {author.user.firstName[0]}
                {author.user.lastName[0]}
              </div>
            )}
            {author.image && (
              <div className={styles.profileImage}>
                {author.image.startsWith('http') ? (
                  <img
                    src={author.image}
                    alt="avatar"
                    className={'w-full object-cover'}
                  />
                ) : (
                  <Image
                    src={
                      author.image.startsWith('/')
                        ? process.env.mediaUrl + author.image?.replace('/', '')
                        : process.env.mediaUrl + author.image
                    }
                    layout={'fill'}
                    objectFit={'cover'}
                  />
                )}
              </div>
            )}
          </div>

          <div className={styles.profileInfoWrapper}>
            <div>
              <div className={cn(styles.profileInfoName, 'font-fragment')}>
                {author.user.firstName}{' '}
                {!!author.user.lastName && author.user.lastName}{' '}
                <a href={author.profile} target={'_blank'}>
                  <LinkedInLogo className={styles.linkedInLogo} />
                </a>
              </div>
              <div className={cn(styles.profileInfoEmail, 'mb-2 text-center')}>
                {author.jobTitle}
              </div>
              {author.alumni && (
                <div className={styles.profileInfoEmail}>{author.alumni}</div>
              )}
              <BCBreadcrumbs
                headerText={
                  `${author.user.firstName}` + ` ${author.user.lastName || ''}`
                }
              />
            </div>
          </div>
        </div>
      </div>

      <div className={cn(styles.profileContents, 'container mb-20')}>
        <div className={styles.authorBioContainer}>
          <h3 className={styles.sectionHeader}>About Author</h3>
          <div className={styles.bio}>{authorBio}</div>
        </div>

        {!!authorContent.length && (
          <>
            <h3 className={styles.sectionHeader}>Most recent content</h3>
            <News news={authorContent} showTitle={false} inverse />
          </>
        )}
      </div>
    </>
  );
}
